export const useUsuarioPageNavLogic = () => {
	return { activePage: window.location.pathname }
}
